import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, ControlLabel, Form, FormControl, FormGroup, Modal} from "react-bootstrap";
import Loading from "../../../Loading";
import {certificateGetFields, certificateGetOwner, certificateUpdateOwner} from 'api';

class OwnerEditor extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            certificate: null,
            isLoadingCertificate: false,
            registrationId: null,
            registration: null,
            isLoading: true,
            fields: null,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        const {certificate, isLoadingCertificate} = this.state;
        const {registrationId} = this.props;

        if (!certificate && !isLoadingCertificate) {
            this.fetchCertificate();
        }

        if (registrationId && this.state.registrationId !== registrationId) {
            this.fetchOwner(registrationId);
        }

    }

    fetchCertificate()
    {
        const {event} = this.props;

        this.setState({certificate: null, isLoadingCertificate: true});

        certificateGetFields(event.eventPassword)
            .then(certificate => this.setState({certificate, isLoadingCertificate: false}));
    }

    fetchOwner(registrationId)
    {
        const {event} = this.props;

        this.setState({registrationId, registration: null, isLoading: true});

        certificateGetOwner(event.eventPassword, registrationId)
            .then(registration => this.setState({registration, fields: registration.fields, isLoading: false}))
    }

    changeProperty(name, value)
    {
        const fields = Object.assign({}, this.state.fields, {[name]: value});

        this.setState({fields});
    }

    saveProperty(name, value)
    {
        const {event, registrationId} = this.props;

        const data = {[name]: value};

        certificateUpdateOwner(event.eventPassword, registrationId, data);
    }

    render()
    {
        const {registration, fields, isLoading, certificate, isLoadingCertificate} = this.state;
        const {onHide, registrationId} = this.props;

        let content = <Loading />;
        if (!isLoading && registration && !isLoadingCertificate && certificate) {
            content = (
                <Form>
                    <FormGroup>
                        <ControlLabel>eMail</ControlLabel>
                        <FormControl
                            readOnly
                            type="text"
                            value={registration.client.email}
                        />
                    </FormGroup>
                    {Object.keys(fields).map((key) => (
                        <FormGroup key={`field_${key}`}>
                            <ControlLabel>{key}</ControlLabel>
                            <FormControl
                                type="text"
                                value={fields[key]}
                                onChange={e => this.changeProperty(key, e.target.value)}
                                onBlur={(e) => this.saveProperty(key, e.target.value)}
                            />
                        </FormGroup>
                    ))}
                </Form>
            );
        }

        return (
            <Modal show={registrationId > 0} onHide={onHide} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Данные зрителя для сертификата</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {content}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent
    };
};

export default connect(mapStateToProps)(OwnerEditor);
